module.exports = __webpack_public_path__ + "static/media/CUYA_Web_LandingPage_CalloutPhoot_Confusion.8807faf7.jpg";